import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type {
  ViagensBillingFilters,
  ViagensBillingPaginationControl,
  ViagensBillingViagensFilters,
} from 'pages/viagens-controle/types';

type State = {
  filters: ViagensBillingFilters;
  viagensFilters: ViagensBillingViagensFilters;
  paginationControl: ViagensBillingPaginationControl;
  viagensPaginationControl: ViagensBillingPaginationControl;
};

type Actions = {
  updateFilters: (filters: ViagensBillingFilters) => void;
  updateViagensFilters: (filters: ViagensBillingViagensFilters) => void;
  updatePaginationControl: (
    paginationControl: Partial<ViagensBillingPaginationControl>
  ) => void;
  updateViagensPaginationControl: (
    paginationControl: Partial<ViagensBillingPaginationControl>
  ) => void;
  clearBillingsState: () => void;
  clearViagensState: () => void;
};

type Options = {
  persisted?: boolean;
};

const initialPagination = {
  page: 1,
  limit: 10,
};

const getInitialState = (): State => ({
  filters: {},
  viagensFilters: {},
  paginationControl: initialPagination,
  viagensPaginationControl: initialPagination,
});

const createStore = (set: any) => ({
  ...getInitialState(),
  updateFilters: (filters: ViagensBillingFilters) => set({ filters }),
  updateViagensFilters: (viagensFilters: ViagensBillingViagensFilters) =>
    set({ viagensFilters }),
  updatePaginationControl: (
    paginationControl: Partial<ViagensBillingPaginationControl>
  ) => {
    return set((state: State) => ({
      paginationControl: {
        ...state.paginationControl,
        ...paginationControl,
      },
    }));
  },
  updateViagensPaginationControl: (
    viagensPaginationControl: Partial<ViagensBillingPaginationControl>
  ) => {
    return set((state: State) => ({
      viagensPaginationControl: {
        ...state.viagensPaginationControl,
        ...viagensPaginationControl,
      },
    }));
  },
  clearBillingsState: () =>
    set((state: State) => ({
      ...state,
      filters: {},
      paginationControl: initialPagination,
    })),
  clearViagensState: () =>
    set((state: State) => ({
      ...state,
      viagensFilters: {},
      viagensPaginationControl: initialPagination,
    })),
});

const store = create<State & Actions>(createStore);

const persistStore = create(
  persist<State & Actions>(createStore, {
    name: 'viagens-billing-search-params',
    version: 2,
    migrate: (persistedState: any) => {
      const state = {
        ...persistedState,
        filters: { ...(persistedState?.filters ?? {}) },
        viagensFilters: { ...(persistedState?.viagensFilters ?? {}) },
      };

      delete state.filters.carrierId;
      delete state.viagensFilters.carrierId;

      return state as State & Actions;
    },
  })
);

export const useViagensBillingSearchParams = (options?: Options) => {
  return options?.persisted ? persistStore() : store();
};
